export { default } from './ValuePropositionsBlock';
export * from './ValuePropositionsBlock';